/* @flow */

import * as React from 'react';

export function FormsPlaceholder() {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 469 341'>
            <g clipPath='url(#a)' opacity='.2'>
                <path fill='#fff' d='M0 0h469v341H0z' />
                <rect width='250' height='21' fill='#4D4540' rx='4' />
                <rect width='410' height='14' y='60' fill='#4D4540' rx='4' />
                <rect width='77' height='14' y='113' fill='#4D4540' rx='4' />
                <rect width='469' height='33' y='136' fill='#4D4540' opacity='.3' rx='4' />
                <rect width='77' height='14' y='208' fill='#4D4540' rx='4' />
                <rect width='469' height='33' y='231' fill='#4D4540' opacity='.3' rx='4' />
                <rect width='68' height='38' x='401' y='303' fill='#4D4540' rx='4' />
            </g>
            <defs>
                <clipPath id='a'>
                    <path fill='#fff' d='M0 0h469v341H0z' />
                </clipPath>
            </defs>
        </svg>
    );
}
